const state = {
    modalVisible: false,
    product: null,
    hideModal: false
};

const mutations = {
    toggleModal(state, value) {
        state.modalVisible = value;
    },
    setState(state, payload) {
        state[payload.state] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    mutations
}
